<template>
  <div
    v-if="content"
    :style="tooltipStyles"
    class="tooltip"
    :class="{ 'tooltip--below': showBelow }"
  >
    {{ content }}
  </div>
</template>

<script lang="ts">
export default {
  name: "Tooltip",
  props: {
    content: { type: String, required: true },
    position: { type: Object, required: true },
  },
  data() {
    return {
      showBelow: false,
    };
  },
  watch: {
    position(newPos,oldPos) {
        const margin = 100;
        if (newPos.y < margin) {
          this.showBelow = true;
        } else {
          this.showBelow = false;
        }
    },
    
  },
  computed: {
    tooltipStyles() {
      return {
        top: `${this.position.y}px`,
        left: `${this.position.x}px`,
      };
    },
  },
};
</script>

<style scoped>
.tooltip {
  position: absolute;
  transform: translate(-50%, calc(-100% - 15px)); /* Par défaut au-dessus */
  z-index: 1000;
  background-color: var(--bg);
  text-align: center;
  color: #fff;
  padding: 10px 15px;
  border-radius: 10px;
  max-width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  transition: transform 0.1s ease;
}

.tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--bg) transparent transparent transparent;
}

/* Quand le tooltip est en dessous */
.tooltip--below {
  transform: translate(-50%, 15px);
}

.tooltip--below::after {
  top: auto;
  bottom: 100%;
  border-color: transparent transparent var(--bg) transparent;
}
</style>
